
import { postNewStudentForm, getSchoolYear, getStudentLastRequestComplete, getStudentDetail } from '../api.js'
import requestFormService from '../formSubmission/requestForm.js'

import pageApiData from '../utils/pageApiData.js'

const [ _getSchoolYearFromServer, _getSchoolYear, _getSchoolYearSync ] = pageApiData.createFunctions(getSchoolYear, 'Unable to get school year data from server.', function (code) { return elem => elem.code === code })

// import pageApiData from '../utils/pageApiData.js'
import requestFormUtil from '../utils/requestFormUtil.js'
import notifications from '../notifications.js'

function _getNewRequestFormOptionsFromCapability(user) {
  if (user === undefined) {
    return Promise.resolve([[],[],])
  }

  let capViewNewRequestForm = user.getCapability('view_new_request_form')

  let districtOptions = capViewNewRequestForm.getDistrictOptions()
  let schoolYearOptions = capViewNewRequestForm.getSchoolYearOptions()

  let promiseDistrict = requestFormService.getDistrictFromServer()
    .then(() => {
      return districtOptions.map(function (option) {
        let district = requestFormService.getDistrictSync(option.district)
        return {
          label: `${option.district} -- ${district.name}`,
          value: option.district,
        }
      })
    })
  let promiseSchoolYear = _getSchoolYearFromServer()
    .then(() => {
      return schoolYearOptions.map(function (option) {
        let schoolYear = _getSchoolYearSync(option.schoolYear)
        return {
          label: schoolYear.display,
          value: option.schoolYear,
        }
      })
    })

  return Promise.all([promiseDistrict, promiseSchoolYear])
}

async function _setRequestFormValues(dbId) {
  let data = (await getStudentLastRequestComplete(dbId)).data

  if (data.schedule_request === null) {
    let studentDetail = (await getStudentDetail(data.student.db_id, { select: 'studentInfo' })).data
    data.schedule_request = requestFormUtil.remapStudentDetailToFormValues(studentDetail)
  }

  data = requestFormUtil.preprocessRequestFormValues(data)

  return data
}

function _postNewStudentForm(content) {
  let promise = postNewStudentForm(content)

  promise
    .then(() => {
      notifications.pushInfo('All validation complete, form submitted.')
    })
    .catch(error => {
      notifications.pushError(`Form submission failed! ${error.response.data}`, error)
    })

  return promise
}

function _init() {
  // do nothing
}

_init()

export default {
  getSchoolYearFromServer: _getSchoolYearFromServer,
  getSchoolYear: _getSchoolYear,
  getSchoolYearSync: _getSchoolYearSync,

  getNewRequestFormOptionsFromCapability: _getNewRequestFormOptionsFromCapability,
  setRequestFormValues: _setRequestFormValues,
  postNewStudentForm: _postNewStudentForm,
}
